export var ButtonGroupCssClass;
(function (ButtonGroupCssClass) {
    ButtonGroupCssClass["Base"] = "iress-button-group";
    ButtonGroupCssClass["Button"] = "iress-button-group__button";
    ButtonGroupCssClass["Label"] = "iress-button-group__label";
    ButtonGroupCssClass["Container"] = "iress-button-group__container";
})(ButtonGroupCssClass || (ButtonGroupCssClass = {}));
//# sourceMappingURL=button-group.types.js.map